const formatBankAccount = (value) => {
  if (!value) return '';

  // 1. Limpa o valor, removendo caracteres não permitidos e convertendo para maiúsculas.
  let cleanValue = value.toString().replace(/[^0-9a-zA-Z]/g, '').toUpperCase();

  // 2. Limita o comprimento total para 12 caracteres (11 conta + 1 dígito).
  if (cleanValue.length > 12) {
    cleanValue = cleanValue.slice(0, 12);
  }

  // 3. Usa uma expressão regular para inserir o hífen antes do último caractere.
  // Ex: "12345X" se torna "12345-X".
  if (cleanValue.length > 1) {
    return cleanValue.replace(/^(.*)(.)$/, '$1-$2');
  }

  return cleanValue;
};

const bankAccountFormat = {
  mounted(el) {
    const input = el.querySelector('input');

    const listener = (event) => {
      const oldValue = event.target.value;
      const newValue = formatBankAccount(oldValue);

      if (oldValue !== newValue) {
        event.target.value = newValue;
        // Dispara um evento 'input' para garantir que o v-model seja atualizado corretamente.
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };

    el._bankAccountListener = listener;
    // Usa o evento 'input' que é mais apropriado para formatação de valores.
    input.addEventListener('input', listener);
  },
  beforeUnmount(el) {
    const input = el.querySelector('input');
    if (input && el._bankAccountListener) {
      input.removeEventListener('input', el._bankAccountListener);
    }
  },
};

export default bankAccountFormat;
